import { render } from "./CoursesContents.vue?vue&type=template&id=5b3f4a5a&scoped=true"
import script from "./CoursesContents.vue?vue&type=script&lang=js"
export * from "./CoursesContents.vue?vue&type=script&lang=js"

import "./CoursesContents.vue?vue&type=style&index=0&id=5b3f4a5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b3f4a5a"

export default script